//formulario sin llamada
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const FormStyle10 = () => {
  const { t, i18n, ready } = useTranslation();
  const navigate = useNavigate(); // Inicializa el hook de navegaciónconst navigate = useNavigate(); // Inicializa el hook de navegación
    const [formData, setFormData] = useState({
      situacionFamiliar: '',
      otraSituacion: '',
      impedimentoMedico: '',
      tipoProcesoDeseado: '',
      informacion: '',
      claridad: '',
      nacionalidadConyuge1:'',
      nacionalidadConyuge2: '',
      nombreApellidos: '',
      emailInfo: '',
      paises: '',
      edad: '',
      observacionesAdicionales: '',
      acceptTerms: false
    });
  
    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const response = await fetch('https://www.gestlifesurrogacy.com/formularios/formStyle10.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        if (response.ok) {
          alert('Formulario enviado con éxito');
           // Redirigir a la página /gracias/
         navigate(t('navigation_redirect', '/'));
        } else {
          throw new Error('Error al enviar el formulario');
        }
      } catch (error) {
        alert('Error al enviar el formulario: ' + error.message);
      }
    };

    if (!ready) {
      return null; // o un spinner/cargando...
    }

    const currentLanguage = i18n.language;
  
    return (
      <div className="container mt-5">
        <form onSubmit={handleSubmit} className="bg-light p-4 rounded shadow-sm">
          {/* Form Header */}
          <div className="form-header mb-4">
            <h3 className="text-center">{t('info_form_title')}</h3>
            <p className="text-center text-muted">{t('info_form_subtitle')}</p>
          </div>
  
          {/* Form Body */}
          <div className="form-body">
            {/* Who are */}
            {currentLanguage !== 'de' && (
            <div className="form-group mb-4">
              <label className="form-label">{t('info_who')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Pareja heterosexual casada menos de un año"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('hetero_couple_married_one')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Pareja heterosexual mas de un año"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('hetero_couple_married_two')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Pareja heterosexual no casada"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('hetero_couple_three')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Hombre soltero o divorciado"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('single_div')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Homosexual casado"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('homo_married')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Homosexual casado"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('homo_married')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Homosexual no casado"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('homo_single')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Pareja mujeres no casadas"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('wom_nomarried')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Pareja mujeres casadas"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('wom_married')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Pareja mujeres casadas"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('woman_single_div')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="situacionFamiliar"
                  value="Persona trans"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                  {t('trans_person')}
                </label>
              </div>
              <div className="form-check">
              <label className="form-check-label">
                  {t('other_genre')}
                </label>
                <input
                  type="text"
                  name="situacionFamiliar"
                  onChange={handleChange}
                  className="form-control"
                />
             
              </div>
            </div>
          )}

             {/* Advisor Name */}
             <div className="form-group mb-4">
              <label className="form-label">{t('if_hetero_couple')}</label>
              <input
                type="text"
                name="impedimentoMedico"
                onChange={handleChange}
                value={formData.asesor}
                className="form-control"
              />
            </div>
  
            {/* Nacionadisel */}
            <div className="form-group mb-4">
              <label className="form-label">{t('wish_process')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="tipoProcesoDeseado"
                  value="Donante ovulos"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('with_one')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="tipoProcesoDeseador"
                  value="Nuestros propios ovocitos"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('with_two')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="tipoProcesoDeseador"
                  value="Embriones en otra clinica"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('with_three')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="tipoProcesoDeseador"
                  value="Material genetico otra clinica"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('with_four')}
                </label>
              </div>
            </div>
  
            {/* Nacionality one */}
            <div className="form-group mb-4">
              <label className="form-label">{t('nationality_one')}</label>
              <input
                type="text"
                name="nacionalidadConyuge1"
                onChange={handleChange}
                value={formData.asesor}
                className="form-control"
              />
            </div>

            {/* Nacionality two */}
            <div className="form-group mb-4">
              <label className="form-label">{t('nationality_two')}</label>
              <input
                type="text"
                name="nacionalidadConyuge2"
                onChange={handleChange}
                value={formData.asesor}
                className="form-control"
              />
            </div>

            {/* Name surname */}
            <div className="form-group mb-4">
              <label className="form-label">{t('name_info')}</label>
              <input
                type="text"
                name="nombreApellidos"
                onChange={handleChange}
                value={formData.asesor}
                className="form-control"
              />
            </div>

             {/* Email */}
             <div className="form-group mb-4">
              <label className="form-label">{t('emailInfo')}</label>
              <input
                type="text"
                name="nombreApellidos"
                onChange={handleChange}
                value={formData.asesor}
                className="form-control"
              />
            </div>

            {/* Country */}
            <div className="form-group mb-4">
              <label className="form-label">{t('country_preference')}</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Ucrania"
                  onChange={handleChange}
                  required
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_one')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Georgia"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_two')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Albania"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_three')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Grecia"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_four')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Usa"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_five')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Armenia"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_six')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Kazajistan"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_seven')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Mexico"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_eight')}
                </label>
              </div>
              
            
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Colombia"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_nine')}
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="paises"
                  value="Chipre"
                  onChange={handleChange}
                  className="form-check-input"
                />
                <label className="form-check-label">
                {t('country_select_ten')}
                </label>
              </div>
            </div>

             {/* Age */}
             <div className="form-group mb-4">
              <label className="form-label">{t('observation_info')}</label>
              <input
                type="text"
                name="edad"
                onChange={handleChange}
                value={formData.asesor}
                className="form-control"
              />
            </div>
  {/* Submit Button */}
  <div className="form-group text-center">
              <button type="submit" className="btn btn-primary btn-lg">
              {t('satisfaction_send_btn')}    
              </button>
            </div>





          
         </div>
        </form>
      </div>
    );
  };
  
  export default FormStyle10;